import domReady from '@wordpress/dom-ready';
import $ from 'jquery';

function mergeFigures() {
	const sliderElements = document.querySelectorAll(
		'[rel="partners-slider"]'
	);
	sliderElements.forEach( ( sliderElement ) => {
		// Remove existing merged container if present
		const existing = sliderElement.querySelector( '.all-partners' );
		if ( existing ) {
			// Move figures back to their original containers
			const figures = existing.querySelectorAll( '.wp-block-image' );
			const rows = sliderElement.querySelectorAll(
				'.wp-block-licht-concept-blocks-partners-row:not(.all-partners)'
			);
			let i = 0;
			figures.forEach( ( figure ) => {
				if ( rows[ i ] ) {
					rows[ i ].appendChild( figure );
					i = ( i + 1 ) % rows.length;
				}
			} );
			existing.remove();
		}
		if ( window.innerWidth <= 1023 ) {
			return;
		}

		let sliderCount = 0;
		const sliders = sliderElement.querySelectorAll(
			'.wp-block-licht-concept-blocks-partners-row:not(.all-partners)'
		);
		const allFiguresContainer = document.createElement( 'div' );
		allFiguresContainer.className =
			'all-partners wp-block-licht-concept-blocks-partners-row row-flow-ltr';
		sliders.forEach( function ( item ) {
			const value = item.style.getPropertyValue( '--sliders-count' );
			sliderCount += parseInt( value );
			const figures = item.querySelectorAll( '.wp-block-image' );
			figures.forEach( ( figure ) => {
				allFiguresContainer.appendChild( figure );
			} );
		} );
		allFiguresContainer.style.setProperty( '--sliders-count', sliderCount );
		sliderElement.appendChild( allFiguresContainer );
	} );
}

window.addEventListener( 'load', mergeFigures );
window.addEventListener( 'resize', mergeFigures );

// window.addEventListener( 'load', () => {
// 	if ( window.innerWidth <= 1023 ) {
// 		return;
// 	}
// 	let figures = [];
// 	let sliderCount = 0;
// 	const sliderElements = document.querySelectorAll(
// 		'[rel="partners-slider"]'
// 	);
//
// 	sliderElements.forEach( ( sliderElement ) => {
// 		const sliders = sliderElement.querySelectorAll(
// 			'.wp-block-licht-concept-blocks-partners-row'
// 		);
// 		const allFiguresContainer = document.createElement( 'div' );
// 		allFiguresContainer.className =
// 			'all-partners wp-block-licht-concept-blocks-partners-row row-flow-ltr';
// 		sliders.forEach( function ( item ) {
// 			const value = item.style.getPropertyValue( '--sliders-count' );
// 			sliderCount += parseInt( value );
// 			figures = item.querySelectorAll( '.wp-block-image' );
// 			figures.forEach( ( figure ) => {
// 				allFiguresContainer.appendChild( figure );
// 			} );
// 		} );
// 		allFiguresContainer.style.setProperty( '--sliders-count', sliderCount );
// 		sliderElement.appendChild( allFiguresContainer );
// 	} );
//
// 	// const sliders = $( '[rel="partners-slider"]' ),
// 	// 	settings = {
// 	// 		dots: false,
// 	// 		arrows: false,
// 	// 		mobileFirst: true,
// 	// 		infinite: true,
// 	// 		autoplay: true,
// 	// 		// rows: 1,
// 	// 		// slidesPerRow: 7,
// 	// 		centerMode: true,
// 	// 		// centerPadding: '50px',
// 	// 		autoplaySpeed: 0,
// 	// 		speed: 2000,
// 	// 		cssEase: 'linear',
// 	// 		responsive: [
// 	// 			{
// 	// 				breakpoint: 320,
// 	// 				settings: {
// 	// 					rows: 2,
// 	// 					slidesPerRow: 4,
// 	// 					// autoplaySpeed: 5000,
// 	// 				},
// 	// 			},
// 	// 			{
// 	// 				breakpoint: 768,
// 	// 				settings: {
// 	// 					rows: 1,
// 	// 					slidesToShow: 7,
// 	// 					centerMode: true,
// 	// 					centerPadding: '150px',
// 	// 					// autoplaySpeed: 1000,
// 	// 				},
// 	// 			},
// 	// 		],
// 	// 	};
// 	// sliders.slick( settings );
// 	// console.log( { settings } );
// } );
